import axios from '@/backend/vue-axios/axios'
import i18n from '../../lang'
import Vue from 'vue'
import store from '@/store'
import Mailcheck from "mailcheck"

import {
  confirmUserEntities,
  declineUserEntity,
  createUserEntities
} from '@/backend/userEntities'
import {
  UPDATE_USERS_DATA,
  UPDATE_USERS_COUNT,
  UPDATE_SEARCH_WORDS,
  UPDATE_CURRENT_PAGE,
  RESET_CURRENT_PAGE,
  UPDATE_IS_MANAGER
} from '../types'
import {
  searchUsers,
  getUser,
  createUser,
  createUserPublicly,
  updateUser,
  deleteUser,
  activateUser,
  getManageableResources,
  getManageableResourcesWithEntityCode,
  downloadUsers,
  updateProfile,
  notDisturb,
  recallUser,
  getCoworkers,
  getDestroyUserPermission,
  shareOfferToSelectedManagers,
  getManagersForSharing,
  validateStatusEmail,
  sendMailCandidate,
  checkUserExistenceInEntity,
  getEntitiesForMultiAction,
  getUserWithEntities,
  loadServicesMail
} from '@/backend/users'


const SET_USER = "SET_USER";
const RESET_USER = "RESET_USER";
const CREATE_USER = "CREATE_USER";
const CREATE_USER_SUCCESS = "CREATE_USER_SUCCESS";
const CREATE_USER_FAILED = "CREATE_USER_FAILED";
const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS";
const UPDATE_USER_FAILED = "UPDATE_USER_FAILED";
const SET_MANAGEABLE_RESOURCES = "SET_MANAGEABLE_RESOURCES";
const SET_MANAGER_FROM_ENTITY = "SET_MANAGER_FROM_ENTITY";
const SET_SERVICES_MAIL = "SET_SERVICES_MAIL";
const GET_ENTITY_SUCCESS = "GET_ENTITY_SUCCESS";
const GET_ENTITY_FAILED = "GET_ENTITY_FAILED";
const REMOVE_ERRORS = "REMOVE_ERRORS"
const UPDATE_TOTAL_PAGES = "UPDATE_TOTAL_PAGES";
const UPDATE_ENTITY_CODE_VALIDITY = "UPDATE_ENTITY_CODE_VALIDITY"
const SET_COWORKERS = "SET_COWORKERS"
const SET_SORT_FIELD = 'SET_SORT_FIELD';
const SET_SORT_ORDER = 'SET_SORT_ORDER';
const SET_MANAGERS_FOR_SHARING = 'SET_MANAGERS_FOR_SHARING';
const SET_ACTIVE_TAB = "SET_ACTIVE_TAB";
const SET_ADDONS = 'SET_ADDONS'
const SET_ADDON = 'SET_ADDON'
const SET_ADDON_POPUP_KEY = 'SET_ADDON_POPUP_KEY'
const SET_ENTITY = 'SET_ENTITY'
const SET_ENTITY_ID = 'SET_ENTITY_ID'
const SET_SINGLE_ENTITY = 'SET_SINGLE_ENTITY'
const SET_UNIQUE_HUB = 'SET_UNIQUE_HUB'
const SET_SIBLING_ENTITIES = 'SET_SIBLING_ENTITIES'
const SET_ENTITIES_FOR_MULTI_ACTION = 'SET_ENTITIES_FOR_MULTI_ACTION'
const SET_MULTI_ACTION_TYPE = 'SET_MULTI_ACTION_TYPE'
const SET_WORKING_USER = 'SET_WORKING_USER'
const SET_EMAIL_SUGGESTION = 'SET_EMAIL_SUGGESTION'

const DEFAULT_USER_ATTRIBUTES = {
  email: '',
  first_name: '',
  last_name: '',
  phone: '',
  password: '',
  role: 'candidate',
  affiliated_service: null,
  entities: [],
  services: [],
  occupations: [],
  add_ons: [],
  resource_type: 'intern',
  acceptCGU: false,
  unavailability_dates_provider_id: null,
  civility: '',
  birthdate: '',
  birthplace: '',
  address: '',
  social_security_number: '',
  salary_category: '',
  salary: '',
  validating_manager: {},
  adding_manager: {}
}

const DEFAULT_USER_RESOURCES = {
  services: [],
  occupations: []
}

const state = {
  perPage: 25,
  searchWord: '',
  minSearchLength: 3,
  stateList: ['active', 'confirmed', 'pending'],
  users: {
    active: {state: 'active', data: {}, total: 0, currentPage: 1, totalPage: 0, sortField: 'last_name', sortOrder: 'asc' },
    confirmed: {state: 'confirmed', data: {}, total: 0, currentPage: 1, totalPage: 0, sortField: 'id', sortOrder: 'asc' },
    pending: {state: 'pending', data: {}, total: 0, currentPage: 1, totalPage: 0, sortField: 'id', sortOrder: 'asc' }
  },
  services_mail: {
    candidates_apply_other_service: {active: false, services: []},
    candidates_validates_other_service: {active: false, services: []},
    recruiter_offer_cancelled_in_service: {active: false, services: []}
  },
  user: Object.assign({}, DEFAULT_USER_ATTRIBUTES),
  manageableHubs: [],
  manageableServices: [],
  manageableOccupations: [],
  managersFromEntity: [],
  manageableEntities: [],
  managersForSharingOptions: [],
  entityCodeValidity: false,
  timeCodes: [],
  allServices: [],
  allHubs: [],
  errors: [],
  coworkers: [],
  activeTab: "active",
  addOns: [],
  addOnPopupKey: 0,
  singleEntity: false,
  entityId: null, // kept for now. It is still used on some components
  entity: null,
  addOnsChange: 0,
  siblingEntities: [],
  entitiesForMultiAction: [],
  multiActionType: '',
  workingUser: null,
  emailSuggestion: ""
}

export const actions = {
  searchAllStates({commit}, entityId){
    commit(UPDATE_IS_MANAGER, false)
    var promises = []
    state.stateList.forEach(function(userState) {
      promises.push(store.dispatch('users/searchAtState', {userState, entityId}))
    })
    return Promise.all(promises)
  },
  searchUsersList({commit}, entityId) {
    state.isManager == true ? store.dispatch('users/searchAtState', {userState: 'active', entityId}) : store.dispatch('users/searchAllStates', entityId)
  },
  searchAtState({commit}, {userState, entityId}) {
    var params = {
      entity_id: entityId,
      searched_keyword: state.searchWord,
      state: userState,
      is_manager: state.isManager,
      page: state.users[userState].currentPage,
      per_page: state.perPage,
      offset: 0,
      sort_order: state.users[userState].sortOrder,
      sort_field: state.users[userState].sortField
    }

    return searchUsers(params).then( (response) => {
      var total = parseInt(response.headers['x-total']);
      var totalPage = parseInt(response.headers['x-total-pages']);
      var usersData = {userState: userState, data: response.data, total: total, totalPage: totalPage};
      if(usersData.data.length == 0 && state.users[userState].currentPage > 1){
        data = {userState: userState, entityId: entityId, currentPage: (state.users[userState].currentPage - 1)}
        store.dispatch('users/searchWithPaginate', data)
      }else{
        commit(UPDATE_USERS_DATA, usersData);
        commit(UPDATE_USERS_COUNT, usersData);
        commit(UPDATE_TOTAL_PAGES, usersData);
      }
    })
  },
  searchByText({commit}, {searchWord, entityId}){
    commit(UPDATE_SEARCH_WORDS, searchWord)
    if(searchWord.length == 0 || searchWord.length >= state.minSearchLength){
      commit(RESET_CURRENT_PAGE)
      store.dispatch('users/searchUsersList', entityId)
    }
  },
  searchWithPaginate({commit}, data){
    commit(UPDATE_CURRENT_PAGE, data)
    store.dispatch('users/searchAtState', { userState: data.userState, entityId: data.entityId })

  },
  searchManagers({commit}, { entityId }) {
    commit(UPDATE_IS_MANAGER, true)
    return store.dispatch('users/searchAtState', { userState: 'active', entityId })
  },
  create ({ commit }, user) {
    return new Promise((resolve, reject) => {
      createUser(user)
        .then( (response) => {
          commit(CREATE_USER_SUCCESS, response.data);
          resolve(response.data)
        })
        .catch(error =>{
          commit(CREATE_USER_FAILED, error.response.data.error);
          reject(error.response)
        })
    })
  },
  createPublicly ({ commit }, user) {
    return createUserPublicly(user)
    .then( (response) => {
      commit(CREATE_USER_SUCCESS, response.data);
    })
    .catch(error =>{
      commit(CREATE_USER_FAILED, error.response.data.error)
    })
  },
  validateStatusEmail({ commit }, email) {
    return new Promise((resolve, reject) => {
      validateStatusEmail(email)
        .then(response => resolve(response.data))
        .catch(error => reject(error.response))
    })
  },
  checkUserExistenceInEntity({ commit }, params) {
    return new Promise((resolve, reject) => {
      checkUserExistenceInEntity(params)
        .then(response => resolve(response.data))
        .catch(error => reject(error.response))
    })
  },
  sendMailCandidate({ commit }, email) {
    return sendMailCandidate(email)
  },
  get({ commit }, { userId, entityId }) {
    return getUser(userId, entityId)
    .then( (response) => {
      commit(SET_USER, response.data);
    })
    .catch(error =>{
      var message = {type: 'danger', content: error.response.data.error}
      store.dispatch('message/enable', message)
    })
  },
  update({ commit }, user) {
    return updateUser(user)
    .then( (response) => {
      commit(UPDATE_USER_SUCCESS, response.data);
    })
    .catch(error =>{
      commit(UPDATE_USER_FAILED, error.response.data.error);
    })
  },
  updateAndActivate({ commit, dispatch }, {user, entityId}) {
    return new Promise((resolve, reject) => {
      return updateUser(user)
        .then(response => {
          const payload = {
            user: user,
            entityId: entityId,
            action: 'activate'
          }
          dispatch('handleMultiAction', payload)
            .then(() => resolve(response.data))
            .catch(error => reject(error))
        })
        .catch(error => {
          commit(UPDATE_USER_FAILED, error.response.data.error);
          reject(error)
        })
    })
  },
  updateProfile({ commit, dispatch }, user_params) {
    user_params = Object.assign(user_params, {services_mail: state.services_mail});
    return updateProfile(user_params)
    .then( (response) => {
      dispatch('auth/setUser', response.data, { root: true });
      return response;
    })
    .catch(error => {
      dispatch('message/enable', { type: 'danger', content: error.response.data.error }, { root: true });
      return error.response;
    })
  },
  initManageableOptions({ commit }, {entityId, hubIds, hubOption} = {}) {
    return new Promise((resolve, reject) => {
      return getManageableResources(entityId, hubIds, hubOption)
        .then( (response) => {
          commit(SET_MANAGEABLE_RESOURCES, response.data);
          resolve(response.data)
        })
        .catch(error => {
          store.dispatch('message/enable', { type: 'danger', content: error.response.data.error })
          reject(error)
        })
    })
  },
  updateManageableOptions ({ commit }, { entityCode, email }) {
    return getManageableResourcesWithEntityCode(entityCode, email)
    .then((response) => {
      commit(SET_MANAGEABLE_RESOURCES, response.data)
      commit(SET_ENTITY, response.data.entity)
      commit(SET_ENTITY_ID, response.data.entity.id)
      commit(GET_ENTITY_SUCCESS)
    })
    .catch(error => {
      store.dispatch('message/enable', { type: 'danger', content: error.response.data.error })
      commit(GET_ENTITY_FAILED, error.response.data.error)
    })
  },
  updateEntityCodeValidity ({ commit }, entityCodeValidity) {
    commit(UPDATE_ENTITY_CODE_VALIDITY, entityCodeValidity)
  },
  removeErrors ({ commit }) {
    commit(REMOVE_ERRORS)
  },
  deleteUser({commit}, {user, entityId, entityIds}) {
    return deleteUser(user.id, entityIds).then( (response) => {
      var content = i18n.t('messages.user_delete_success', {name: `${user.first_name} ${user.last_name}`});
      var message = { type: 'success', content: content }
      store.dispatch('message/enable', message)
      store.dispatch('users/searchUsersList', entityId);
    }).catch(err =>{
      var message = { type: 'danger', content: err.response.data.error }
      store.dispatch('message/enable', message)
    })
  },
  activateUser({ commit }, { user, entityId, entityIds, requireReLoadUsers = true }) {
    return activateUser(entityIds, user.id).then( (response) => {
      var content = i18n.t('messages.user_active_success', {name: `${user.first_name} ${user.last_name}`});
      var message = { type: 'success', content: content };
      store.dispatch('message/enable', message);
      if(requireReLoadUsers) {
        store.dispatch('users/searchUsersList', entityIds[0]);
        store.dispatch('dashboard/getLatestConfirmedUsers', entityId)
        store.dispatch('dashboard/getLatestActiveUsers', entityId);
      }
    }).catch(err =>{
      var message = { type: 'danger', content: err.response.data.message };
      store.dispatch('message/enable', message);
    })
  },
  reset({ commit }, role) {
    commit(RESET_USER, role);
  },
  activeNotDisturb ({ commit }, date) {
    return notDisturb(date)
    .then((response) => {
      store.dispatch('auth/setUser', response.data);
      return response;
    })
    .catch(error => {
      store.dispatch('message/enable', { type: 'danger', content: error.response.data.message })
      return error.response
    })
  },
  recallUser({ commit }, {user, entityId}) {
    return recallUser(entityId, user.id).then( (response) => {
      var content = i18n.t('messages.user_recall_success',
                           {name: `${user.first_name} ${user.last_name}`});
      var message = { type: 'success', content: content }
      setTimeout(() => {
        store.dispatch('message/enable', message)
      }, 500)
    }).catch(err => {
      var content = i18n.t('messages.user_recall_error',
                           {name: `${user.first_name} ${user.last_name}`});
      var message = { type: 'danger', content: content }
      setTimeout(() => {
        store.dispatch('message/enable', message)
      }, 500)
    })
  },
  getCoworkers ({ commit }, entity_id) {
    return getCoworkers(entity_id)
    .then( (response) => {
      commit(SET_COWORKERS, response.data);
    })
    .catch(error => {
      store.dispatch('message/enable', { type: 'danger', content: error.response.data.error })
    })
  },
  getDestroyUserPermission({ commit }, { userId, entityId }) {
    return getDestroyUserPermission(userId, entityId)
    .then(response => response)
    .catch(error => {
      store.dispatch('message/enable', { type: 'danger', content: error.response.data.error })
    })
  },
  setSortField({ commit }, sortField){
    commit(SET_SORT_FIELD, sortField)
  },
  setSortOrder({ commit }, sortOrder){
    commit(SET_SORT_ORDER, sortOrder)
  },
  initManagersForSharingOptions({ commit }){
    return getManagersForSharing()
    .then(response => {
      commit(SET_MANAGERS_FOR_SHARING, response.data)
    })
    .catch(error => {
      store.dispatch('message/enable', { type: 'danger', content: error.response.data.error })
    })
  },
  shareOfferToSelectedManagers({ commit }, sendingList) {
    return shareOfferToSelectedManagers(sendingList)
    .catch(error => {
      store.dispatch('message/enable', { type: 'danger', content: error.response.data.error })
    })
  },
  download({ commit }, params){
    return downloadUsers(params)
      .then((response) => {
        var blob = new Blob([response.data], { type: params['file_type'] === 'csv' ? 'text/csv' : 'application/vnd.ms-excel' });
        var users_type = params.is_manager ? 'managers' : 'candidats';
        var filename = `export_${users_type}_${moment().format("YYYY-MM-DD")}.${params['file_type']}`;

        let link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        setTimeout(function(){
          document.body.removeChild(link);
          window.URL.revokeObjectURL(link.href);
        }, 100);
      })
  },
  handleMultiAction({ commit, dispatch }, { user, entityId, action }) {
    return getEntitiesForMultiAction(user.id, action).then((response) => {
      let entities = response.data
      entities = entities.map(entity => {
        return { ...entity, selected: entityId == entity.id }
      })
      if (entities.length > 1) {
        commit(SET_MULTI_ACTION_TYPE, action)
        commit(SET_ENTITIES_FOR_MULTI_ACTION, entities)
        commit(SET_WORKING_USER, user)
        $('#candidate-multi-action-popup').modal('show')
      } else {
        const payload = {
          user: user,
          entityId: entityId,
          entityIds: [entities[0].id]
        }
        dispatch(`${action}User`, payload)

        const addOns = state.addOns.map(addOn => {
          return { ...addOn, aasm_state: 'active'}
        })
        commit(SET_ADDONS, addOns)
      }
    })
  },
  setActiveTab({commit}, activeTab){
    commit(SET_ACTIVE_TAB, activeTab)
  },
  confirmUserEntities({ dispatch }, userEntities) {
    return new Promise((resolve, reject) => {
      confirmUserEntities(userEntities)
        .then(async response => {
          dispatch('message/enable', { type: 'success', content: response.data.message }, { root: true });

          resolve(response.data);
        }).catch(error => {
          dispatch('message/enable', { type: 'danger', content: error.response }, { root: true });
          reject(error);
        })
    });
  },
  declineUserEntity({ dispatch }, userEntity) {
    return new Promise((resolve, reject) => {
      declineUserEntity(userEntity.entity.id)
        .then(async response => {

          resolve(response.data);
        }).catch(error => {
          dispatch('message/enable', { type: 'danger', content: error.response }, { root: true });
          reject(error);
        })
    });
  },
  createUserEntities({ dispatch }, userEntities) {
    return new Promise((resolve, reject) => {
      createUserEntities(userEntities).then(async response => {
        dispatch('message/enable', { type: 'success', content: response.data.message }, { root: true });

        resolve(response.data);
      }).catch(error => {
        dispatch('message/enable', { type: 'danger', content: error.response }, { root: true });
        reject(error);
      });
    })
  },
  getUserWithEntities({ commit }) {
    return getUserWithEntities()
      .then((response) => {
        return Promise.resolve(response.data);
      })
  },
  getEntitiesForMultiAction({ commit }, { user, entityId, action }) {
    return getEntitiesForMultiAction(user.id, action)
      .then((response) => {
        let entities = response.data
        entities = entities.map(entity => {
          return { ...entity, selected: entityId == entity.id }
        })
        if (entities.length > 1) {
          store.commit('users/SET_MULTI_ACTION_TYPE', action)
          store.commit('users/SET_ENTITIES_FOR_MULTI_ACTION', entities)
          store.commit('users/SET_WORKING_USER', user)
          $('#candidate-multi-action-popup').modal('show')
        } else {
          if (action == 'refuse') {
            action = 'delete'
          }
          const payload = {
            user: user,
            entityId: entityId,
            entityIds: [entities[0].id]
          }
          store.dispatch(`users/${action}User`, payload)
        }
      })
  },
  getManagersEntityOptions({commit}, {entityId}) {
    var params = {
      entity_id: entityId,
      is_manager: true,
      light_serializer: true,
      no_paginate: true
    }
    return searchUsers(params)
    .then((response) => {
      commit(SET_MANAGER_FROM_ENTITY, response.data)
    }).catch(error => {
      dispatch('message/enable', { type: 'danger', content: error.response }, { root: true });
      reject(error);
    });
  },
  loadServicesMail({commit}) {
    return loadServicesMail()
      .then((response) => {
        commit(SET_SERVICES_MAIL, response.data)
      })
  },
  verifyEmail({ commit }, email) {
    Mailcheck.run({
      email: email,
      suggested: function (suggestion) {
        commit('SET_EMAIL_SUGGESTION' , suggestion.full)
      }
    })
  },
  resetMailSuggestion({commit}) {
    commit('SET_EMAIL_SUGGESTION' , "")
  }
}

export const mutations = {
  [UPDATE_USERS_DATA] (state, usersData) {
    Vue.set(state.users[usersData.userState], 'data', usersData.data)
  },
  [UPDATE_USERS_COUNT] (state, usersData) {
    Vue.set(state.users[usersData.userState], 'total', usersData.total)
  },
  [UPDATE_SEARCH_WORDS] (state, searchWord) {
    Vue.set(state, 'searchWord', searchWord)
  },
  [UPDATE_CURRENT_PAGE] (state, data) {
    Vue.set(state.users[data.userState], 'currentPage', data.currentPage)
  },
  [RESET_CURRENT_PAGE] (state) {
    state.stateList.forEach(function(userState) {
      Vue.set(state.users[userState], 'currentPage', 1)
    })
  },
  [SET_SERVICES_MAIL] (state, value) {
    state.services_mail = value
  },
  [UPDATE_IS_MANAGER] (state, value) {
    state.isManager = value
  },
  [CREATE_USER_SUCCESS] (state, user) {
    state.user = Object.assign({}, DEFAULT_USER_ATTRIBUTES);
    state.errors = [];
  },
  [CREATE_USER_FAILED] (state, errors) {
    state.errors = errors;
  },
  [UPDATE_USER_SUCCESS] (state, user) {
    state.user = Object.assign({}, DEFAULT_USER_ATTRIBUTES);
    state.errors = [];
  },
  [UPDATE_USER_FAILED] (state, errors) {
    state.errors = errors;
  },
  [SET_MANAGEABLE_RESOURCES] (state, resources) {
    state.manageableOccupations = resources.occupations;
    state.manageableHubs = resources.hubs;
    state.manageableServices = resources.services;
    state.allServices = resources.all_services;
    state.allHubs = resources.hubs;
    state.timeCodes = resources.time_codes;

    // fix temporaire
    if (resources.entities !== undefined) {
      state.singleEntity = resources.entities.length == 1
    } else {
      state.singleEntity = resources.single
    }
    if (resources.entities) {
      state.manageableEntities = resources.entities
    } else {
      state.manageableEntities = []
    }
  },
  [SET_EMAIL_SUGGESTION] (state, suggestion) {
    state.emailSuggestion = suggestion
  },
  [SET_MANAGER_FROM_ENTITY] (state, managers) {
    state.managersFromEntity = managers;
  },
  [SET_USER] (state, user) {
    state.user = user;
  },
  [RESET_USER] (state, role) {
    state.user = Object.assign({}, DEFAULT_USER_ATTRIBUTES);
    state.user.role = role;
  },
  [GET_ENTITY_SUCCESS] (state) {
    state.entityCodeValidity = true;
    state.errors = [];
  },
  [GET_ENTITY_FAILED] (state, errors) {
    state.user = Object.assign(state.user, DEFAULT_USER_RESOURCES)
    state.entityCodeValidity = false;
    state.errors = errors;
  },
  [UPDATE_ENTITY_CODE_VALIDITY] (state, entityCodeValidity) {
    state.entityCodeValidity = entityCodeValidity
  },
  [REMOVE_ERRORS] (state) {
    state.errors = [];
  },
  [UPDATE_TOTAL_PAGES] (state, data) {
    Vue.set(state.users[data.userState], 'totalPage', data.totalPage)
  },
  [SET_COWORKERS] (state, data) {
    state.coworkers = data
  },
  [SET_SORT_FIELD] (state, sortField) {
    state.users.active.sortField = sortField
    state.users.confirmed.sortField = sortField
    state.users.pending.sortField = sortField
  },
  [SET_SORT_ORDER] (state, sortOrder) {
    state.users.active.sortOrder = sortOrder
    state.users.confirmed.sortOrder = sortOrder
    state.users.pending.sortOrder = sortOrder
  },
  [SET_MANAGERS_FOR_SHARING] (state, managersList) {
    state.managersForSharingOptions = managersList
  },
  [SET_ACTIVE_TAB] (state, activeTab) {
    state.activeTab = activeTab
  },
  [SET_ADDONS] (state, addOns) {
    state.addOns = addOns
    state.addOnsChange += 1
  },
  [SET_ADDON_POPUP_KEY] (state) {
    state.addOnPopupKey += 1
  },
  [SET_ADDON] (state, addOn) {
    state.addOns[addOn.index] = addOn
    state.addOnsChange += 1
  },
  [SET_ENTITY] (state, entity) {
    state.entity = entity
  },
  [SET_ENTITY_ID] (state, entityId) {
    state.entityId = entityId
  },
  [SET_SINGLE_ENTITY] (state, value) {
    state.singleEntity = value
  },
  [SET_SIBLING_ENTITIES] (state, entities) {
    state.siblingEntities = entities
  },
  [SET_ENTITIES_FOR_MULTI_ACTION] (state, entities) {
    state.entitiesForMultiAction = entities
  },
  [SET_MULTI_ACTION_TYPE] (state, actionType) {
    state.multiActionType = actionType
  },
  [SET_WORKING_USER] (state, workingUser) {
    state.workingUser = workingUser
  },
}

export const getters = {
  usersData: state => {
    return state.users
  },
  perPage: state => {
    return state.perPage
  },
  searchWord: state => {
    return state.searchWord
  },
  user: state => {
    return state.user
  },
  allUsers: state => {
    return state.allUsers
  },
  errors: state => {
    return state.errors
  },
  hasErrors: state => {
    if (state.errors) {
      return state.errors.length > 0
    }
    return false
  },
  manageableHubs: state => {
    return state.manageableHubs
  },
  emailSuggestion: state => {
    return state.emailSuggestion
  },
  manageableServices: state => {
    return state.manageableServices
  },
  servicesMail: state => {
    return state.services_mail
  },
  manageableOccupations: state => {
    return state.manageableOccupations
  },
  managersFromEntity: state => {
    return state.managersFromEntity
  },
  manageableEntities: state => {
    return state.manageableEntities
  },
  isSingleEntity: state => {
    return state.singleEntity
  },
  timeCodes: state => {
    return state.timeCodes
  },
  entityCodeValidity: state => {
    return state.entityCodeValidity
  },
  email: state => {
    return state.user.email
  },
  allServices: state => {
    return state.allServices
  },
  allHubs: state => {
    return state.allHubs
  },
  totalPage: state => {
    return {
      active: state.users.active.totalPage,
      confirmed: state.users.confirmed.totalPage,
      pending: state.users.pending.totalPage
    }
  },
  coworkers: state => {
    return state.coworkers
  },
  managersForSharingOptions: state => {
    return state.managersForSharingOptions
  },
  currentPage: state => {
    return {
      active: state.users.active.currentPage,
      confirmed: state.users.confirmed.currentPage,
      pending: state.users.pending.currentPage
    }
  },
  activeTab: state => {
    return state.activeTab
  },
  addOnPopupKey: state => {
    return state.addOnPopupKey
  },
  addOns: state => {
    return state.addOns
  },
  entity: state => {
    return state.entity
  },
  entityId: state => {
    return state.entityId
  },
  addOnsChange: state => {
    return state.addOnsChange
  },
  siblingEntities: state => {
    return state.siblingEntities
  },
  entitiesForMultiAction: state => {
    return state.entitiesForMultiAction
  },
  multiActionType: state => {
    return state.multiActionType
  },
  workingUser: state => {
    return state.workingUser
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/users.js